import * as React from 'react';
export const appleSvg = React.forwardRef(function appleSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.308 7.63c-.8.95-2.082 1.698-3.367 1.592-.16-1.285.469-2.65 1.204-3.497.8-.975 2.204-1.672 3.341-1.725.132 1.338-.387 2.653-1.178 3.63Zm1.166 1.847c-1.86-.106-3.448 1.057-4.333 1.057-.894 0-2.244-1.003-3.714-.976-1.91.026-3.686 1.11-4.661 2.838-2.004 3.456-.522 8.57 1.416 11.383.947 1.393 2.082 2.921 3.58 2.865 1.418-.05 1.976-.922 3.689-.922 1.722 0 2.216.922 3.714.897 1.55-.025 2.526-1.393 3.473-2.787 1.082-1.578 1.523-3.119 1.55-3.2-.025-.025-2.991-1.165-3.02-4.593-.025-2.865 2.339-4.23 2.445-4.312-1.335-1.981-3.417-2.196-4.14-2.25Z',
      fill: '#fff',
    }),
  );
});
appleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var apple = {
  category: 'brand',
  colorable: false,
  name: 'apple',
  svg: appleSvg,
};
